export default class SearchOrderRelease {
  orderReleaseId: string;
  purchaseOrderId: string;
  earlyPickupDate: string | null;
  earlyPickupDateBefore: string | null;
  latePickupDate: string | null;
  latePickupDateBefore: string | null;
  shipTo: string;
  freightTerms: string;
  shipmentId: string;
  poCreationDate: string | null;
  poCreationDateBefore: string | null;
  earlyDeliveryDate: string | null;
  earlyDeliveryDateBefore: string | null;
  lateDeliveryDate: string | null;
  lateDeliveryDateBefore: string | null;
  appointmentId: string;

  constructor(
    orderReleaseId: string,
    purchaseOrderId: string,
    earlyPickupDate: string | null,
    earlyPickupDateBefore: string | null,
    latePickupDate: string | null,
    latePickupDateBefore: string | null,
    shipTo: string,
    freightTerms: string,
    shipmentId: string,
    poCreationDate: string | null,
    poCreationDateBefore: string | null,
    earlyDeliveryDate: string | null,
    earlyDeliveryDateBefore: string | null,
    lateDeliveryDate: string | null,
    lateDeliveryDateBefore: string | null,
    appointmentId: string
  ) {
    this.orderReleaseId = orderReleaseId;
    this.purchaseOrderId = purchaseOrderId;
    this.earlyPickupDate = earlyPickupDate;
    this.earlyPickupDateBefore = earlyPickupDateBefore;
    this.latePickupDate = latePickupDate;
    this.latePickupDateBefore = latePickupDateBefore;
    this.shipTo = shipTo;
    this.freightTerms = freightTerms;
    this.shipmentId = shipmentId;
    this.poCreationDate = poCreationDate;
    this.poCreationDateBefore = poCreationDateBefore;
    this.earlyDeliveryDate = earlyDeliveryDate;
    this.earlyDeliveryDateBefore = earlyDeliveryDateBefore;
    this.lateDeliveryDate = lateDeliveryDate;
    this.lateDeliveryDateBefore = lateDeliveryDateBefore;
    this.appointmentId = appointmentId;
  }
}
